var React = require('react');

function ShitBgInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M292.053 42.971C277.288 -0.698193 221.006 -11.9415 190.735 22.7345L16.6798 222.126C-13.603 256.815 4.86077 311.41 49.8914 320.402L308.831 372.104C353.855 381.096 391.705 337.767 376.936 294.076L292.053 42.971Z","fill":"#2E7943"}));
}

ShitBgInline.defaultProps = {"width":"382","height":"375","viewBox":"0 0 382 375","fill":"none"};

module.exports = ShitBgInline;

ShitBgInline.default = ShitBgInline;
